
import { defineComponent, computed, ref, reactive, SetupContext } from 'vue';

export default defineComponent({
  name: 'TEmpty',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: [String, Array],
      default: '',
    },
    top: {
      type: Number,
      default: 0,
    },
    right: {
      type: Number,
      default: 0,
    },
    bottom: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'static',
      validator: (value: string) => ['static', 'fixed'].includes(value),
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-empty');
    // 组件坐标的四个位置值
    const positionInfo = ref({
      top: props.top,
      right: props.right,
      bottom: props.bottom,
      left: props.left,
    });
    const clientWidth = ref(0);
    const clientHeight = ref(0);
    clientWidth.value = document.documentElement.clientWidth;
    clientHeight.value = document.documentElement.clientHeight;
    positionInfo.value = {
      top: (props.top / clientHeight.value) * 100,
      right: (props.right / clientWidth.value) * 100,
      bottom: (props.bottom / clientHeight.value) * 100,
      left: (props.left / clientWidth.value) * 100,
    };
    const getStyles = computed(() => {
      if (props.type === 'fixed') {
        const output = {} as {
          top: string;
          right: string;
          bottom: string;
          left: string;
        };
        if (props.top) {
          output.top = `${positionInfo.value.top}%`;
        }
        if (props.right) {
          output.right = `${positionInfo.value.right}%`;
        }
        if (props.bottom) {
          output.bottom = `${positionInfo.value.bottom}%`;
        }
        if (props.left) {
          output.left = `${positionInfo.value.left}%`;
        }
        return output;
      }
      return {
        padding: `${props.top}% ${props.right}% ${props.bottom}% ${props.left}%`,
      };
    });

    // 判断是否为字符串
    const getIsString = computed(() => typeof props.content === 'string');

    /** 组件的className前辍 */
    const getClasses = computed(() => {
      return {
        wrap: [prefixCls.value, `${prefixCls.value}-type__${props.type}`],
        title: [
          `${prefixCls.value}-title`,
          context.slots.icon && `${prefixCls.value}-title__mt`,
          props.content && `${prefixCls.value}-title__mb`,
        ],
        description: [`${prefixCls.value}-desc`],
      };
    });
    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, getStyles, getIsString, listener };
  },
});
